module.exports = __webpack_public_path__ + "img/banner5@2x.049ec1f3.png";